export default "__VITE_PUBLIC_ASSET__b4b3f62e__"